import { render, staticRenderFns } from "./roishop.vue?vue&type=template&id=61ceb2e6&scoped=true"
import script from "./roishop.vue?vue&type=script&lang=js"
export * from "./roishop.vue?vue&type=script&lang=js"
import style0 from "./roishop.vue?vue&type=style&index=0&id=61ceb2e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ceb2e6",
  null
  
)

export default component.exports